import { Dispatch, SetStateAction } from "react";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import { MainImage } from "../workDetailPage/WorkMainImage";
import Navigator from '../components/Navigation';
import { WorkFullImage } from "../workDetailPage/WorkFullImage";
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { ArticleMainImage } from "../articleDetailPage/ArticleMainImage";
import image1 from '../image/articles/creative3-1.webp';
import article2Thumbnail from '../image/articles/article2_1.webp';
import ProtectedPage from "../components/ProtectedPage";
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import YouTubeEmbed from "../components/YouTubeEmbed";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';

function Creative3(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
    const hashedPasswords = hashPasswordsFromEnv(
      process.env.REACT_APP_CREATIVE3_PASSWORDS
    );
      const images1 = [image1]; // 1개 이미지
      
      useMetaTags({
        title: '2025 연말 게임 파티 - Lynkim',
        description: '서바이벌 게임 | 루시퍼 이펙트',
        image: '/ogimage.png',
      });
      
      return (
        <>
        {/* <ProtectedPage password={hashedPasswords} description="이번 게임에 참여한 인원: O명"> */}
              <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
              <div className='fadeIn '>
                  <ArticleTitle
                      title={'2025 연말 게임 파티'}
                      description={'서바이벌 게임 | 루시퍼 이펙트'}
                      category={'creative'}
                      date={'2025.12.19.'} />
              </div>
              <Wavedivider />
              <ArticleTextSection
                  description={<div>
                      <CalloutLink href="https://www.figma.com/proto/3zgYRCaBss8OEICSCdhMjb/Untitled?page-id=0%3A1&node-id=1-713&p=f&viewport=109%2C105%2C0.03&t=jIDRNTxJoiXFM8lu-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=1%3A713&show-proto-sidebar=1">
                          서바이벌 게임 | 루시퍼 이펙트
                      </CalloutLink>
                  </div>} />
              <div className='articleLayout'>
                  <ArticleImageLayout images={images1} />
              
              
            </div>
          <BackButton />
          
        {/* </ProtectedPage> */}
        </>
      )
  }
  
  export default Creative3;
